const FONT_INCONSOLATA = 'Inconsolata';
const FONT_INTER = 'Inter';

const FONT_SIZE_DEFAULT = '1rem';
const FONT_SIZE_MOBILE = '0.8rem';
const FONT_SIZE_PARAGRAPH = '1rem';
const FONT_SIZE_SMALL = '0.75rem';
const FONT_SIDEBAR = '0.875rem';

const DEFAULT_LINE_HEIGHT = 1.25;
const HEADING_LINE_HEIGHT = 1.25;
const PARAGRAPH_LINE_HEIGHT = 1.5;

const MOBILE_LINE_HEIGHT = 1.25;

const BASE_TYPOGRAPHY_HEADING = `
  font-family: ${FONT_INTER};
  font-weight: 700;
  line-height: ${HEADING_LINE_HEIGHT};
`;

const BASE_TYPOGRAPHY_BODY = `
  font-family: ${FONT_INTER};
  line-height: ${DEFAULT_LINE_HEIGHT};
  // font-weight: normal;
`;

const MOBILE_TYPOGRAPHY_BODY = `
  font-family: ${FONT_INTER};
  line-height: ${MOBILE_LINE_HEIGHT};
  // font-weight: normal;
`;
const typography = {
  sizes: {
    default: FONT_SIZE_DEFAULT,
    paragraph: FONT_SIZE_PARAGRAPH,
    small: FONT_SIZE_SMALL,
    sidebar: FONT_SIDEBAR,
  },
  headingBase: BASE_TYPOGRAPHY_HEADING,
  bodyBase: BASE_TYPOGRAPHY_BODY,

  heading1: `
    ${BASE_TYPOGRAPHY_HEADING}
    font-size: 2.5rem;
  `,
  heading2: `
    ${BASE_TYPOGRAPHY_HEADING}
    font-size: 2.625rem;
  `,
  heading3: `
    ${BASE_TYPOGRAPHY_HEADING}
    font-size: 1.25rem;
  `,
  heading4: `
    ${BASE_TYPOGRAPHY_HEADING}
    font-size: 1.125rem;
  `,
  heading5: `
    ${BASE_TYPOGRAPHY_HEADING}
    font-size: 1rem;
    text-transform: uppercase;
  `,
  heading6: `
    ${BASE_TYPOGRAPHY_HEADING}
    font-size: 1rem;
  `,
  UIText: `
    ${BASE_TYPOGRAPHY_BODY}
    font-size: ${FONT_SIZE_DEFAULT};    
  `,
  MobileUIText: `
    ${MOBILE_TYPOGRAPHY_BODY}
    font-size: ${FONT_SIZE_MOBILE};    
  `,
  UITextSmall: `
    ${BASE_TYPOGRAPHY_BODY}
    font-size: ${FONT_SIZE_SMALL};
  `,
  paragraph: `
    ${BASE_TYPOGRAPHY_BODY}
    font-size: ${FONT_SIZE_PARAGRAPH};
    line-height: ${PARAGRAPH_LINE_HEIGHT};
  `,
  paragraphCode: `
    font-family: ${FONT_INCONSOLATA};
    font-size: ${FONT_SIZE_DEFAULT};
    // font-weight: normal;
  `,

  defaultLineHeight: DEFAULT_LINE_HEIGHT,
  paragraphLineHeight: PARAGRAPH_LINE_HEIGHT,
  mobileParagraphLineHeight: DEFAULT_LINE_HEIGHT,
};

export default typography;
